import React from 'react'

const Flipbook = ({ data }) => {
  return (
    <div className="flipbook">
      <div dangerouslySetInnerHTML={{ __html: data.iframe }}></div>
    </div>
  )
}

export default Flipbook
